/**
 * The strip an operator sees on a marketing page opened with `?draft=<id>`
 * from `#/platform/website` (P3-21).
 *
 * 🔴 IT SAYS "NOT LIVE" IN WORDS. A draft rendered on the real page looks
 * exactly like the published site, which is the point of previewing it — and
 * exactly why the one thing that differs must say so, or an operator closes
 * the tab believing visitors can already see the change.
 *
 * Only ever rendered when the server returned the draft to a signed-in
 * operator; a visitor following the same link gets the published page and no
 * strip.
 */
export function DraftBar({ version, back }: { version: number; /** The console address to return to. */ back: string }) {
  return (
    <div
      role="status"
      className="fixed inset-x-0 bottom-0 z-100 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 border-t border-line bg-ink px-4 py-2.5 font-dash text-dash-xs font-bold text-surface"
    >
      <span>Draft v{String(version)} — not live. Visitors still see the published page.</span>
      <a
        href={back}
        className="rounded-pill border border-surface/40 px-3 py-1 outline-none hover:bg-surface/10 focus-visible:ring-2 focus-visible:ring-surface"
      >
        Back to Website
      </a>
    </div>
  );
}
